import { Component, Injector, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { AssinaturaDto, PlanoDto, PlanoServiceProxy, PublicoAlvoEnum } from '@shared/service-proxies/service-proxies';
import { Router } from '@angular/router';
import { TipoAssinaturaService } from '@shared/services/tipo-assinatura.service';
import { Location } from '@angular/common';

@Component({
  selector: 'card-plano',
  templateUrl: './card-plano.component.html',
  styleUrls: ['./card-plano.component.scss']
})

export class CardPlanoComponent extends AppComponentBase implements OnInit {

  @Input() publicoAlvo: PublicoAlvoEnum;
  @Input() assinatura: AssinaturaDto;
  @Input() planoAtual: PlanoDto;
  @Input() isAnual: boolean = true;
  protected planos: PlanoDto[] = [];
  protected planoSelecioando: PlanoDto;
  protected assinaturaAnual: boolean = true;
  @Input() mostrarVoltar: boolean = false;

  constructor(
    injector: Injector,
    private readonly _planoService: PlanoServiceProxy,
    private readonly _tipoAssinaturaService: TipoAssinaturaService,
    private _router: Router,
    private _location: Location
  ) { super(injector) }

  ngOnInit(): void {
    this.assinaturaAnual = this.assinatura?.tipoAssinaturaString == 'Anual';
    this.getPlanos();
  }

  private getPlanos(): void {
    abp.ui.setBusy();
    this._planoService.getPlanosByPublicoAlvo(this.publicoAlvo).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.planos = result;
    });
  }

  protected selecionarPlano(plano: PlanoDto): void {
    this._tipoAssinaturaService.valor = this.isAnual;
    this.planoSelecioando = plano;
    if (this.mostrarVoltar) {
      this._router.navigate(["app", "pagamento", plano.id], {
        queryParams: { origem: "minha-assinatura" }
      });
    } else {
      this._router.navigate(["app", "pagamento", plano.id]);
    }
  }

  protected setIsAnual(value: boolean): void {
    this._tipoAssinaturaService.valor = value;
    this.isAnual = value;
  }
}
